import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const EMISSION_TARGET_AND_GROUPS_API_REDUCER_KEY =
  "emissionTargetGroupAndItemApi";

export const emissionTargetGroupAndItemApi = createApi({
  reducerPath: EMISSION_TARGET_AND_GROUPS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["target-groups"],
  endpoints: (builder) => ({
    getTargetGroupsList: builder.query({
      query: ({ page, limit, type }) => {
        return {
          url: `emissions/emission-target-groups/?page=${page}&type=${type}&limit=${limit}&created_at=-created_at`,
        };
      },
      providesTags: ["target-groups"],
    }),

    getTargetGroup: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `emissions/emission-target-groups/${id}/`,
        };
      },
      providesTags: ["target-groups"],
    }),

    createTargetGroup: builder.mutation({
      query: (body) => ({
        url: `emissions/emission-target-groups/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["target-groups"],
    }),

    updateTargetGroup: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `emissions/emission-target-groups/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["target-groups"],
    }),

    deleteTargetGroup: builder.mutation({
      query: (id) => ({
        url: `emissions/emission-target-groups/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["target-groups"],
    }),
    getTargetItemsList: builder.query({
      query: ({ page, limit, target_groups }) => {
        return {
          url: `emissions/emission-target-items/?page=${page}&target_groups=${target_groups}&limit=${limit}&sort=-created_at`,
        };
      },
      providesTags: ["target-groups"],
    }),

    getTargetItem: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `emissions/emission-target-items/${id}/`,
        };
      },
      providesTags: ["target-groups"],
    }),
    bulkUpdateTargetItems: builder.mutation({
      query: (body) => {
        return {
          url: `emissions/emission-target-items/bulk-update/`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["target-groups"],
    }),
  }),
});

export const {
  useCreateTargetGroupMutation,
  useDeleteTargetGroupMutation,
  useGetTargetGroupQuery,
  useGetTargetGroupsListQuery,
  useUpdateTargetGroupMutation,
  useGetTargetItemQuery,
  useGetTargetItemsListQuery,
  useBulkUpdateTargetItemsMutation,
} = emissionTargetGroupAndItemApi;
